import { render, staticRenderFns } from "./ListImCustomsClearance.vue?vue&type=template&id=1df3318e&scoped=true&"
import script from "./ListImCustomsClearance.vue?vue&type=script&lang=js&"
export * from "./ListImCustomsClearance.vue?vue&type=script&lang=js&"
import style0 from "./ListImCustomsClearance.vue?vue&type=style&index=0&id=1df3318e&lang=scss&scoped=true&"
import style1 from "./ListImCustomsClearance.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df3318e",
  null
  
)

export default component.exports